import React from 'react';
import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';

const SpinnerContainer = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
  };
});

const MaterialSpinner = (props) => {
  return (
    <SpinnerContainer {...props}>
      <CircularProgress size={65} />
    </SpinnerContainer>
  );
};

export default MaterialSpinner;
